__turbopack_context__.v({
  "caption": "investorLoginForm-module-scss-module__uzg-sW__caption",
  "compatibilityLinkContainer": "investorLoginForm-module-scss-module__uzg-sW__compatibilityLinkContainer",
  "customInvestorLoginContainer": "investorLoginForm-module-scss-module__uzg-sW__customInvestorLoginContainer",
  "customLoginForm": "investorLoginForm-module-scss-module__uzg-sW__customLoginForm",
  "customLoginFormLabel": "investorLoginForm-module-scss-module__uzg-sW__customLoginFormLabel",
  "customLoginFormLabelIcon": "investorLoginForm-module-scss-module__uzg-sW__customLoginFormLabelIcon",
  "customMessage": "investorLoginForm-module-scss-module__uzg-sW__customMessage",
  "investorLogin": "investorLoginForm-module-scss-module__uzg-sW__investorLogin",
  "investorLoginContainer": "investorLoginForm-module-scss-module__uzg-sW__investorLoginContainer",
  "loginForm": "investorLoginForm-module-scss-module__uzg-sW__loginForm",
  "loginFormButton": "investorLoginForm-module-scss-module__uzg-sW__loginFormButton",
  "loginFormEntryCode": "investorLoginForm-module-scss-module__uzg-sW__loginFormEntryCode",
  "loginFormInput": "investorLoginForm-module-scss-module__uzg-sW__loginFormInput",
  "loginFormLabel": "investorLoginForm-module-scss-module__uzg-sW__loginFormLabel",
  "loginFormLabelIcon": "investorLoginForm-module-scss-module__uzg-sW__loginFormLabelIcon",
  "terms": "investorLoginForm-module-scss-module__uzg-sW__terms",
  "title": "investorLoginForm-module-scss-module__uzg-sW__title",
});
